import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Player extends Phaser.GameObjects.Sprite {
    name: string;
    hasBall: boolean;
    canShoot: boolean;
    canPass: boolean;
    canThrow: boolean;
    animation: Phaser.Animations.Animation;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.properties["frame"]);

        this.hasBall = false;
        this.canPass = ob.properties["canPass"];
        this.canShoot = ob.properties["canShoot"];
        this.canThrow = ob.properties["canThrow"];
        this.name = ob.name;

        this.createAnim();

        this.scene.add.existing(this);   
    }

    createAnim() {
        if (this.canPass) {
            this.animation = this.scene.anims.create({
                key: this.name + "kick",
                frames: [
                    { key: "assets", frame: "home1" },
                    { key: "assets", frame: "home2" },
                    { key: "assets", frame: "home1" },
                ],
                frameRate: 9,
            });
        }
        else if (this.canThrow) {
            this.animation = this.scene.anims.create({
                key: "throw",
                frames: this.scene.anims.generateFrameNames("assets", { prefix: "throw", start: 1, end: 3 }),
                frameRate: 5
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/games/StarballGame/objects/Player.ts